export const REGULATION_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'public_agent_module_permission',
  'group_module_permission',
  'regulatory_agent',
  'service',
  'panel',
  'service_request',
  'service_request_dashboard',
]
